import React from 'react';
import {observer} from "mobx-react";
import { ChatQuestionsWrapper, ChatQuestionsBox, ChatQuestionsSuggestions, Suggestion } from "./ChatQuestionsSection.styled";

const ChatQuestionsSection = observer(({ onSelectQuestion, isLoading, loadedQuestions, dataTestId }) => {
    const handleShowConversations = (message) => {
        if(!isLoading){
            onSelectQuestion(message);
        }
    };

    return (
        <>
            <ChatQuestionsWrapper data-testid={dataTestId}
            >
                <ChatQuestionsBox>
                    <ChatQuestionsSuggestions>
                        {loadedQuestions.map((question, idx) => (question ?
                            <Suggestion key={idx} onClick={() => handleShowConversations(question)}>
                                <span>{question}</span></Suggestion>:
                            <></>
                        ))}
                    </ChatQuestionsSuggestions>
                </ChatQuestionsBox>
            </ChatQuestionsWrapper>
        </>
    );
});

export default ChatQuestionsSection;
